import type { PropsWithChildren } from "react";
import { Component } from "react";

interface IIconHOCProps {
    componentName: string;
    componentSize: string;
    iconName: string;
    iconSize: string;
}

/**
 * Перехватчик ошибки от использования компонента Icon.
 * Данный перехватчик генерирует более понятную ошибку при использовании компонента Icon в других компонентах.
 */
export class IconSizeErrorBoundary extends Component<
    PropsWithChildren<IIconHOCProps>,
    object
> {
    componentDidCatch(error: Error) {
        // eslint-disable-next-line no-console
        console.log(error.message);

        const { componentName, componentSize, iconSize, iconName } = this.props;
        throw new Error(
            `Для компонента "${componentName}" с размером "${componentSize}" необходима иконка с размером "${iconSize}". С таким размером иконка "${iconName}" не найдена.`,
        );
    }

    render() {
        return this.props.children;
    }
}
